function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M310.226,153.824H201.233c-10.309,0-18.666-8.357-18.666-18.666V26.166c0-10.309,8.357-18.666,18.666-18.666h108.992 c10.309,0,18.666,8.357,18.666,18.666v108.992C328.891,145.467,320.534,153.824,310.226,153.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.729,82.436L255.729,82.436c-12.505,0-22.643-10.138-22.643-22.643V49.628c0-8.699,7.052-15.751,15.751-15.751h13.783 c8.699,0,15.751,7.052,15.751,15.751v10.165C278.372,72.298,268.235,82.436,255.729,82.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M305.164,153.824h-98.869l7.454-30.986c2.152-8.946,10.154-15.252,19.356-15.252h45.251c9.201,0,17.204,6.306,19.356,15.252 L305.164,153.824z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M154.496,420.737v65.097c0,10.309-8.357,18.666-18.666,18.666H26.838c-10.309,0-18.666-8.357-18.666-18.666V376.842 c0-10.309,8.357-18.666,18.666-18.666H135.83c10.309,0,18.666,8.357,18.666,18.666v8.759"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M81.334,433.112L81.334,433.112c-12.505,0-22.643-10.138-22.643-22.643v-10.165c0-8.699,7.052-15.751,15.751-15.751h13.783 c8.699,0,15.751,7.052,15.751,15.751v10.165C103.977,422.974,93.84,433.112,81.334,433.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M130.769,504.5H31.9l7.454-30.986c2.152-8.946,10.154-15.252,19.356-15.252h45.251c9.201,0,17.204,6.306,19.356,15.252 L130.769,504.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M485.162,504.5H376.17c-10.309,0-18.666-8.357-18.666-18.666V376.842c0-10.309,8.357-18.666,18.666-18.666h108.992 c10.309,0,18.666,8.357,18.666,18.666v108.992C503.828,496.143,495.471,504.5,485.162,504.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M430.666,433.112L430.666,433.112c-12.505,0-22.643-10.138-22.643-22.643v-10.165c0-8.699,7.052-15.751,15.751-15.751h13.783 c8.699,0,15.751,7.052,15.751,15.751v10.165C453.309,422.974,443.171,433.112,430.666,433.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M480.1,504.5h-98.869l7.454-30.986c2.152-8.946,10.154-15.252,19.356-15.252h45.251c9.201,0,17.204,6.306,19.356,15.252 L480.1,504.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M381.09,274.04h40.846c17.703,0,32.054,14.351,32.054,32.054v52.086"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M58.01,358.18v-52.086c0-17.703,14.351-32.054,32.054-32.054h40.846"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M291.062,221.983h75.018c8.291,0,15.013,6.721,15.013,15.013v74.097c0,8.291-6.721,15.013-15.013,15.013H145.92 c-8.291,0-15.013-6.721-15.013-15.013v-74.097c0-8.291,6.721-15.013,15.013-15.013H256"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M201.774,298.486l18.355-48.194c0.375-0.917,1.673-0.918,2.05-0.002l18.188,48.196"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 325.076,
    y1: 249.603,
    x2: 325.076,
    y2: 298.486
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 351.371,250.22 326.64,272.952 353.106,298.486 \t\t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M296.004,254.629c0,0-8.771-7.373-19.115-4.257c-9.498,2.861-10.826,13.812-3.955,18.292c0,0,6.742,3.008,14.221,5.766 c18.002,6.64,10.247,24.056-4.245,24.056c-7.257,0-13.348-3.178-17.034-7.246"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 158.894,
    y1: 249.603,
    x2: 185.889,
    y2: 249.603
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 172.337,
    y1: 251.164,
    x2: 172.337,
    y2: 298.486
  }))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 153.824,
    x2: 256,
    y2: 221.983
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 474.151,338.015 453.99,358.176 433.829,338.015 \t"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 78.171,338.015 58.01,358.176 37.849,338.015 \t"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskStatus);
export default __webpack_public_path__ + "static/media/taskStatus.78c5da3af05a138ef118ad4a82cd47ae.svg";
export { ForwardRef as ReactComponent };